import Container from "@mui/material/Container";

const ChildrenWrapper = ({children}) => {

  return(
      <Container
          disableGutters
          sx={{
              pt: 2,
              pb: 4,
              px: {xs: 2, sm: 3, md: 4}
          }}
      >
          {children}
      </Container>
  )
}
export default ChildrenWrapper